module.exports = __webpack_public_path__ + "static/img/BE.55e57e64.png";